module.exports = "/_next/static/images/photoValeriaTulbure-688046eecce53b61225141fd9fa6187b.webp";